import { useEffect } from 'react'
import moment from 'moment'
import App from './app/App'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Watchdog } from '@Techedge/smart-shared'
import { UserHelper, sharedStore } from '@Techedge/digitalportal-shared'
import globalSearchReducer, {
    GLOBAL_SEARCH_REDUCER_NAMESPACE,
} from '@/app/redux/reducers/global-search'

export const locale = UserHelper?._shared()?.user()?.language || 'en-US'
export const userProfile =
    UserHelper?._shared()?.user()?.application_profiles || []

export const dateFormat = moment
    .localeData(locale)
    .longDateFormat('L')
    .toLocaleLowerCase()
    .replace('yyyy', 'yy')

export default function Root(props: any) {
    useEffect(() => {
        sharedStore.injectReducer(
            GLOBAL_SEARCH_REDUCER_NAMESPACE,
            globalSearchReducer
        )
    }, [])

    return (
        <Provider store={sharedStore}>
            <Watchdog
                providerName="NAVBAR"
                userProfile={userProfile[0]?.profile}>
                <BrowserRouter>
                    <App {...props} />
                </BrowserRouter>
            </Watchdog>
        </Provider>
    )
}
